module.exports = __webpack_public_path__ + "static/media/btn_benefit_cate_off.cb13a56f.png";